import { Id, toast } from "react-toastify"

import ThemeToast from "@fuse/sharedComponents/themeToast"

export enum ToastType {
  TOAST_SUCCESS = "success",
  TOAST_ERROR = "error",
  TOAST_INFO = "info",
}

interface ShowThemeToastProps {
  type: ToastType
  text1: string
  text2?: string
  emojiIcon?: string
  iconName?: "success" | "error" | "info"
  showCloseButton?: boolean
  buttonText?: string
  onButtonClick?: () => void
  onClose?: () => void
}

interface CustomToastSettings {
  text2?: string
  emojiIcon?: string
  iconName?: ToastType
  showCloseButton?: boolean
  buttonText?: string
  onButtonClick?: () => void
  onClose?: () => void
}

export const showThemeToast = ({
  type,
  text1,
  text2,
  emojiIcon,
  iconName,
  showCloseButton = false,
  buttonText,
  onButtonClick,
  onClose,
}: ShowThemeToastProps): Id => {
  const isMobile = window.innerWidth <= 600
  const toastPosition = isMobile ? "bottom-center" : "top-right"

  const borderColor =
    type === ToastType.TOAST_SUCCESS
      ? "border-green-500"
      : type === "error"
        ? "border-red-500"
        : "border-blue-500"

  const gradient =
    type === "success"
      ? "from-green-400/50"
      : type === "error"
        ? "from-red-400/50"
        : "from-blue-400/50"

  return toast(
    ({ closeToast }) => (
      <ThemeToast
        type={type}
        text1={text1}
        text2={text2}
        emojiIcon={emojiIcon}
        iconName={iconName}
        onClose={() => {
          onClose && onClose()
          closeToast()
        }}
        showCloseButton={showCloseButton}
        buttonText={buttonText}
        onButtonClick={onButtonClick}
      />
    ),
    {
      className: `w-full max-w-sm border-t-4 ${borderColor} bg-gradient-to-r ${gradient} to-transparent overflow-hidden p-0 bg-transparent shadow-none rounded-lg`,
      closeButton: false, // Disable default close button since we use ToastContainer's
      closeOnClick: true,
      icon: false,
      position: toastPosition,
      autoClose: 5000,
      draggable: true,
      onClose: () => {
        onClose && onClose()
      },
    },
  )
}

export const showSuccessToast = (msg: string, options?: CustomToastSettings) =>
  showThemeToast({
    type: ToastType.TOAST_SUCCESS,
    text1: msg,
    ...options,
  })

export const showErrorToast = (msg: string, options?: CustomToastSettings) =>
  showThemeToast({
    type: ToastType.TOAST_ERROR,
    text1: msg,
    ...options,
  })

export const showInfoToast = (msg: string, options?: CustomToastSettings) =>
  showThemeToast({
    type: ToastType.TOAST_INFO,
    text1: msg,
    ...options,
  })
